<template lang="pug">
  .layout-view__controls
    v-btn(
      medium
      :disabled="!hasPermission('delivery_company', 'add')"
      @click="modals.showCreate = true")
      v-icon(
        position-left
        font-size="1"
        icon="plus").mr-1
      | {{ $t('base.add') }}
    v-dialog(
      max-width="380"
      v-model="modals.showCreate")
      create-modal(@close="modals.showCreate = false")
    v-dialog(
      max-width="380"
      :value="showCompanyEdit"
      @input="closeCompanyDetail")
      edit-modal
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import CreateModal from './modals/CreateModal'
import EditModal from './modals/EditModal'

export default {
  name: 'ControlsPanel',

  components: {
    CreateModal,
    EditModal
  },

  data: () => ({
    modals: {
      showCreate: false
    }
  }),

  methods: {
    ...mapActions('deliveries', [
      'closeCompanyDetail'
    ])
  },

  computed: {
    ...mapGetters('deliveries', [
      'currentCompany'
    ]),

    showCompanyEdit () {
      return this.currentCompany !== null
    }
  }
}
</script>
